import { Error, PaymentShortSummary } from 'components'
import messages from 'i18n/messages'
import flowRight from 'lodash/flowRight'
import { makeSelectCustomer } from 'logic/customers'
import { makeSelectCurOrder } from 'logic/orders'
import { makeSelectCurOrg } from 'logic/orgs'
import { makeSelectError, makeSelectPaymentData, updatePaymentDataAttr, checkVoucherCode, checkPromoCode, makeSelectLoading, makeSelectCodeError } from 'logic/payment'
import React, { Component } from "react"
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Alert, Col, Row } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import CheckoutForm from './Stripe/CheckoutForm'

let stripePromise = null

class StripePaymentForm extends Component {

  componentDidMount () {
    if (stripePromise) return

    stripePromise = loadStripe(process.env.STRIPE_PKEY) //, { stripeAccount: this.props.org.stripe_account_id })
  }

  handleTogglePaymentMethod = ({ target }) => this.props.actions.updatePaymentDataAttr(
    'payment_method',
    target.value,
  )

  render() {
    const { paymentData, donation, customer, org, error, order, values, deliveryMethod, payable } = this.props

    if (error) return <Error error={error} prefix="payment" />
    if (!stripePromise) return <></>
    if (!order && !values) return <></>
    if (!paymentData) return <></>

    if (!org.stripe_payments) return <div>
      <Alert color="danger">
        <FormattedMessage {...messages.orgCannotReceivePayments} values={{ name: org.name}} />
      </Alert>
    </div>

    return (
      <div className={`payment-form ${this.props.hide ? 'hidden' : ''}`}>
        <h2><FormattedMessage {...messages.paymentMethod} /></h2>
        <Row className="align-items-stretch">
          <Col lg={8} className="stripe-elements">
            <Elements stripe={stripePromise}>
              <CheckoutForm
                clientSecret={paymentData.stripe_client_token}
                customer={customer}
                order={order}
                org={org}
                paymentData={paymentData}
              />
            </Elements>
          </Col>
          <Col lg={4}>
            <PaymentShortSummary
              values={values || order.seats}
              payable={payable}
              paymentData={paymentData}
              donation={donation}
              handleSubmit={this.handleSubmit}
              deliveryMethod={deliveryMethod || order.delivery_method}
            />
          </Col>
          {/*
          <FormGroup check className="payment-psd2-checkbox">
            <Label check>
              <Input
                type="checkbox"
                checked={this.state.sendAdditionalContactInfoToPSP}
                onChange={this.handleToggleRegisterNew}
              />
              <span className="form-check-sign" />
              <FormattedMessage {...messages.sendAdditionalDataToPSP} />
            </Label>
            <FormText><FormattedMessage {...messages.sendAdditionalDataToPSPDesc} /></FormText>
          </FormGroup>
          */}
        </Row>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  paymentData: makeSelectPaymentData(),
  customer: makeSelectCustomer(),
  order: makeSelectCurOrder(),
  org: makeSelectCurOrg(),
  error: makeSelectError(),
  codeError: makeSelectCodeError(),
  loading: makeSelectLoading(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updatePaymentDataAttr,
    checkVoucherCode,
    checkPromoCode,
  }, dispatch)
})

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)
export default enhance(StripePaymentForm)
